module.exports = __webpack_public_path__ + "img/appointment-type-zero-design.275da617.png";